(function () {
  'use strict';
  var activeDialog = null;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initPill(pill) {
    if (pill.dataset.rkReady) return;
    pill.dataset.rkReady = 'true';
    var avatars = Array.from(pill.querySelectorAll('[data-rk-social-avatar]'));
    var name = pill.querySelector('[data-rk-social-name]');
    var current = 0;
    var hovered = false;
    var timer;
    function render() {
      avatars.forEach(function (avatar) { avatar.classList.remove('is-active'); });
      for (var slot = 0; slot < Math.min(3, avatars.length); slot++) {
        var avatar = avatars[(current + slot) % avatars.length];
        avatar.style.setProperty('--rk-proof-slot', slot);
        avatar.classList.add('is-active');
      }
      name.textContent = avatars[current].dataset.name;
    }
    function updateTimer() {
      window.clearInterval(timer);
      if (avatars.length <= 1 || reduceMotion.matches) return;
      timer = window.setInterval(function () {
        if (!pill.isConnected) { window.clearInterval(timer); return; }
        if (document.hidden || hovered || pill.contains(document.activeElement)) return;
        current = (current + 1) % avatars.length;
        render();
      }, Math.max(2200, Number(pill.dataset.interval) || 3200));
    }
    pill.addEventListener('mouseenter', function () { hovered = true; });
    pill.addEventListener('mouseleave', function () { hovered = false; });
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', updateTimer);
    if (avatars.length) render();
    updateTimer();
  }

  function initVideos(root) {
    if (root.dataset.rkReady) return;
    root.dataset.rkReady = 'true';
    var dialog = root.querySelector('[data-rk-video-dialog]');
    var stage = root.querySelector('[data-rk-video-player]');
    var source = root.querySelector('[data-rk-video-source]');
    var opener = null;
    function clearPlayer() {
      var video = stage.querySelector('video');
      if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
      var frame = stage.querySelector('iframe');
      if (frame) frame.src = 'about:blank';
      stage.replaceChildren();
      if (activeDialog === dialog) activeDialog = null;
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    }
    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-rk-video-open]');
      if (!trigger || !root.contains(trigger) || typeof dialog.showModal !== 'function') return;
      var type = trigger.dataset.videoType;
      if (type === 'vimeo' && !/^\d+$/.test(trigger.dataset.videoId || '')) return;
      if (type !== 'vimeo' && !trigger.dataset.videoSrc) return;
      event.preventDefault();
      if (activeDialog && activeDialog.open) activeDialog.close();
      document.querySelectorAll('.rk-video-proof video').forEach(function (video) { video.pause(); });
      opener = trigger;
      stage.replaceChildren();
      root.querySelector('[data-rk-video-title]').textContent = trigger.dataset.videoTitle;
      source.href = trigger.href;
      dialog.showModal();
      activeDialog = dialog;
      if (type === 'vimeo') {
        var frame = document.createElement('iframe');
        frame.title = trigger.dataset.videoTitle;
        frame.allow = 'autoplay; fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.src = 'https://player.vimeo.com/video/' + trigger.dataset.videoId + '?autoplay=1&muted=1&controls=1&autopause=1&dnt=1&title=0&byline=0&portrait=0';
        stage.appendChild(frame);
      } else {
        var video = document.createElement('video');
        video.controls = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.poster = trigger.dataset.videoPoster || '';
        video.src = trigger.dataset.videoSrc;
        video.setAttribute('aria-label', trigger.dataset.videoTitle);
        stage.appendChild(video);
        video.play().catch(function () { /* Native controls remain available. */ });
      }
      root.querySelector('[data-rk-video-close]').focus({ preventScroll: true });
    });
    root.querySelector('[data-rk-video-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', clearPlayer);
  }
  function init(scope) {
    scope.querySelectorAll('[data-rk-social-pill]').forEach(initPill);
    scope.querySelectorAll('[data-rk-video-proof]').forEach(initVideos);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (activeDialog && event.target.contains(activeDialog)) activeDialog.close();
  });
})();
